import { Grid } from '@mui/material'
import { ComponentWithElementProps } from '../types'
import ElementSwitcher from './ElementSwitcher'


const GridContainer = ({ element }: ComponentWithElementProps) => {
    return (
        <Grid container {...element.props}>
            {element.childs.map(child => <ElementSwitcher key={child.id} element={child} />)}
        </Grid>
    )
}

export default GridContainer